"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var Input_1 = require("../Input");
var DatePicker_1 = require("../DatePicker");
var ClickOutsideDetector_1 = require("../ClickOutsideDetector");
var react_portal_1 = require("react-portal");
var luxon_1 = require("luxon");
var getPosition_1 = require("../getPosition");
var DatePickerInput = /** @class */ (function (_super) {
    __extends(DatePickerInput, _super);
    function DatePickerInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ref = React.createRef();
        _this.state = {
            x: 0,
            y: 0,
            open: false,
        };
        _this.updatePopup = function () {
            if (_this.ref.current) {
                var current = _this.ref.current;
                var height = current.getBoundingClientRect().height;
                var _a = getPosition_1.getPosition(current), x = _a.x, y = _a.y;
                _this.setState({ x: x + 1, y: y + height + 5 });
            }
        };
        return _this;
    }
    DatePickerInput.prototype.componentDidMount = function () {
        this.updatePopup();
        window.addEventListener('resize', this.updatePopup);
    };
    DatePickerInput.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.updatePopup);
    };
    DatePickerInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, value = _a.value, className = _a.className, onChange = _a.onChange, placeholder = _a.placeholder;
        var _b = this.state, x = _b.x, y = _b.y, open = _b.open;
        var inputValue = value || '';
        return (React.createElement("div", { ref: this.ref, style: style, className: classnames_1.default(styles.datePickerInput, className) },
            React.createElement(Input_1.default, { className: styles.input, value: inputValue, placeholder: placeholder, onChange: function (value) {
                    onChange(value);
                }, onFocus: function () {
                    _this.updatePopup();
                    _this.setState({ open: true });
                } }),
            open && (React.createElement(react_portal_1.Portal, null,
                React.createElement(ClickOutsideDetector_1.default, { onClickOutside: function () {
                        _this.setState({ open: false });
                    } },
                    React.createElement(DatePicker_1.default, { allowChangeCalendar: true, style: { left: x, top: y }, className: styles.datePicker, value: value, onChange: function (selectedDate) {
                            _this.setState({
                                open: false,
                            }, function () {
                                onChange(luxon_1.DateTime.fromJSDate(selectedDate).toFormat('yyyy-MM-dd'));
                            });
                        } }))))));
    };
    return DatePickerInput;
}(React.Component));
exports.default = DatePickerInput;
